'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { GYPSUM } from 'HubStyleTokens/colors';

const renderAlert = troubleshooting => {
  if (!troubleshooting) {
    return null;
  }

  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-x-auto m-bottom-2 text-left",
    type: "info",
    style: {
      maxWidth: 600
    },
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "troubleshoot.alertTitle"
    }),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "troubleshoot.alert"
    })
  });
};

const TroubleshootModeToggle = ({
  troubleshooting,
  toggleTroubleshootMode,
  fetchTroubleshootTimes
}) => {
  useEffect(() => {
    if (troubleshooting) {
      fetchTroubleshootTimes();
    }
  }, [fetchTroubleshootTimes, troubleshooting]);
  const troubleshootMessageKey = troubleshooting ? 'troubleshoot.exit_jsx' : 'troubleshoot.enter1_jsx';
  return /*#__PURE__*/_jsxs("div", {
    className: "p-top-4 text-center",
    style: {
      background: GYPSUM
    },
    children: [renderAlert(troubleshooting), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: troubleshootMessageKey,
      options: {
        onClick: () => toggleTroubleshootMode(!troubleshooting),
        use: 'link',
        'data-selenium-test': 'troubleshoot-button'
      },
      elements: {
        Button: UIButton
      }
    }), !troubleshooting && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "troubleshoot.enter2"
      })
    })]
  });
};

TroubleshootModeToggle.propTypes = {
  troubleshooting: PropTypes.bool.isRequired,
  toggleTroubleshootMode: PropTypes.func.isRequired,
  fetchTroubleshootTimes: PropTypes.func.isRequired
};
export default TroubleshootModeToggle;